import { render, staticRenderFns } from "./WritingWordsForm.vue?vue&type=template&id=e81ece9c&"
import script from "./WritingWordsForm.vue?vue&type=script&lang=js&"
export * from "./WritingWordsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports